import { render, staticRenderFns } from "./CandidateDashboard.vue?vue&type=template&id=9f4e781a&scoped=true"
import script from "./CandidateDashboard.vue?vue&type=script&lang=js"
export * from "./CandidateDashboard.vue?vue&type=script&lang=js"
import style0 from "./CandidateDashboard.vue?vue&type=style&index=0&id=9f4e781a&prod&scoped=true&lang=css"
import style1 from "./CandidateDashboard.vue?vue&type=style&index=1&id=9f4e781a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4e781a",
  null
  
)

export default component.exports